import { uiStore } from 'shared/store/uiStore'
import { Button } from 'shared/ui'
import { LINK_POWER_DIALER } from 'shared/constants/links'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useCallPopUpGlobalContext } from 'widgets/CallPopUp/context/callPopUpGlobalContext'
import styles from './styles.module.scss'

export const usePowerDialerAvailability = () => {
  const { featureFlagsStore, inboxesStore, usersStore } = useEntitiesContext()
  const callPopUpGlobalStore = useCallPopUpGlobalContext()
  const inbox = inboxesStore.currentInbox
  const sharedInboxes = inboxesStore.sharedInboxes
  const currentInbox = inbox?.type === 'inbox' ? inbox : null

  const hasAllShortCode = sharedInboxes.every((item) => item.isShortCode)
  const hasAllAircall = sharedInboxes.every((item) => item.isCallViaAircallActive)
  const hasAllInactiveOutboundCalls = sharedInboxes.every((item) => !item.isNumberOutboundCalls)
  const hasCurrentInactiveOutboundCalls = Boolean(
    currentInbox && !currentInbox.isNumberOutboundCalls
  )

  const hideButton = Boolean(usersStore.user?.isViewOnlyRole || hasAllAircall || hasAllShortCode)

  const isCallOutboundDisabled = currentInbox
    ? hasCurrentInactiveOutboundCalls
    : hasAllInactiveOutboundCalls
  const disabled =
    isCallOutboundDisabled ||
    callPopUpGlobalStore.hasPowerDialerV2 ||
    !featureFlagsStore.inteliquent_calling
  const isAdminOrOwnerRole =
    usersStore.user?.isAdminRole ||
    usersStore.user?.isOwnerRole ||
    (inbox?.type === 'inbox' && inbox?.ownerId === usersStore.user?.id)
  const canManageInboxCalling = featureFlagsStore.settings_inboxes_manage_inbox_calling_v2

  const getTooltipAvailability = () => {
    if (isCallOutboundDisabled) {
      if (isAdminOrOwnerRole) {
        return (
          <div
            onClick={(event) => {
              event.stopPropagation()
            }}
            className={styles.tooltipContainer}
          >
            Outbound calling is disabled
            <br />
            <Button
              tag='a'
              size='medium'
              text='Enable it here'
              typeBtn='link'
              className={styles.linkButton}
              onClick={() => {
                const redirectPath = canManageInboxCalling
                  ? `/settings/inboxes/${inbox?.id}/settings/calling/general`
                  : `/settings/organization/inboxes/all-inboxes/${inbox?.id}/calling`

                uiStore.changeRouteViaVue({
                  path: redirectPath,
                })
              }}
            />
          </div>
        )
      }
      return [
        'Outbound calling is disabled.',
        <br key={'br'} />,
        'Contact your admin to enable it.',
      ]
    }

    return ''
  }

  const getTooltipInfo = () => {
    return (
      <div
        onClick={(event) => {
          event.stopPropagation()
        }}
        className={styles.tooltipContainer}
      >
        Autodial multiple contacts <br />
        <Button
          tag='a'
          size='medium'
          text='Learn more'
          typeBtn='link'
          href={LINK_POWER_DIALER}
          target='_blank'
          rel='noreferrer'
          className={styles.linkButton}
        />
      </div>
    )
  }

  return {
    disabled,
    hideButton,
    getTooltipAvailability,
    getTooltipInfo,
  }
}
